export default __webpack_public_path__ + "static/media/franchise.6d21d7ff.svg";